<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import Vue from 'vue';
import { apiName } from './common/config.js';
import { refConfig } from './common/config/refConfig.js';
import { getEnterpriseConfiguration } from '@/utils/common/initializationPublicData.js';
import isEmpty from 'lodash-es/isEmpty';
import globalMixin from '@/mixins/globalMixin';
import Utils from '@/utils/utils';

Vue.mixin(globalMixin);

export default {
  globalData: {
    waitHandleCount: '0',
    isIphoneX: false, //判断当前手机是否是iphoneX以后的版本（如：iPhone11）
    platformType: -1, // 3: 滴滴平台，2 极速
    sessionId: '',
    sessionTime: '',
    applyListDetail: {
      temporary: null, // 临时
      trip: null, // 出差
    },
    banners: [],
  },
  onLaunch: async function () {
    this.$app.getUrlConfig();
    let settings = this.$app.GetSettings();
    const oldSettings = this.$app.GetSettings();
    settings.webSiteUrl = this.$app.webSiteUrl;
    settings.currentApi = this.$app.apiUrl;
    // settings.platId = this.$app.MemberInfo.PlatId;
    settings.Version = this.$app.MemberInfo.Version;
    // settings.ProcessInstanceId = "";
    // settings.ProcessInstanceRowNumber = "";
    settings.SinglePointLoginProductType = 0;
    settings.bookingProductType = 0;
    // settings.bookingMethod = 1; // 0 因私  1 差旅订单
    // settings.RefId = "";
    this.$app.SetSettings(settings);

    //#ifdef H5
    const path = this.$route.path;
    if (path !== '/' && path !== '' && path !== '/pages/index2.0/start') {
      getEnterpriseConfiguration();
    }
    let parent = document.getElementsByTagName('head')[0];
    let meta = document.createElement('meta');
    meta.setAttribute('name', 'format-detection');
    meta.setAttribute('content', 'telephone=no');
    parent.appendChild(meta);
    let that = this;
    let param = {};
    let needGetLoginUrl = false;
    let EnterpriseId = this.$app.GetQueryString('EnterpriseId') || '0';
    let processInstanceId = decodeURIComponent(this.$app.GetQueryString('ProcessInstanceId') || '');
    let dingdingRowNumber = decodeURIComponent(this.$app.GetQueryString('rowNumber') || '');
    let refId = this.$app.GetQueryString('RefId') || '';
    let platId = this.$app.GetQueryString('platId') || '';
    let productType = this.$app.GetQueryString('Page') || '0';
    let toPage = this.$app.GetQueryString('location') || '';
    let toOrderDetailSerialNo = this.$app.GetQueryString('orderNo') || '';
    let ddCorpId = this.$app.GetQueryString('corpid') || this.$app.GetQueryString('corpId') || '';

    settings.SinglePointLoginProductType = productType;
    let appStatus = this.$app.GetQueryString('appStatus') || '';
    let userStaus = this.$app.GetQueryString('userStatus') || '';
    let journeyBizNo = this.$app.GetQueryString('journeyBizNo') || '';
    if (refId == refConfig.dingdingjijian) {
      if (appStatus == 'NORMAL' && userStaus == 'NO_AUTH') {
        uni.redirectTo({
          url: '/pages/dingding/no_permission?appStatus=' + appStatus + '&userStaus=' + userStaus,
        });
        return;
      }
    }
    if (ddCorpId) {
      // settings.CompanyName = "";
      // settings.corpId = "";
      settings.MemberMac = '';
      settings.EnterpriseId = 0;
      settings.journeyBizNo = '';
      // settings.RefId = "0";
      // settings.isLogin = false;
      this.$app.SetSettings(settings);
    }
    let memberId = decodeURIComponent(this.$app.GetQueryString('memberId'));
    let token = decodeURIComponent(this.$app.GetQueryString('token'));
    const isUrlLogin = memberId !== 'null' && memberId === Utils.get(oldSettings, 'MemberInfo.MemberId', '');
    if (memberId != null && memberId != 'null' && memberId && token != null && token != 'null' && token) {
      if (!settings.MemberInfo) {
        settings.MemberInfo = {};
      }
      settings.MemberInfo.MemberId = memberId.replace(' ', '+');
      settings.MemberInfo.Token = token;
      settings.isLogin = true;
      this.$app.SetSettings(settings);
    } else if (refId == 173) {
      needGetLoginUrl = false;
    } else if (this.$app.MemberInfo.PlatId == 1028 || this.$app.MemberInfo.PlatId == 1029) {
      if (EnterpriseId) {
        needGetLoginUrl = true;
      }
    } else if (this.$app.MemberInfo.PlatId == 1033 || this.$app.MemberInfo.PlatId == 1035) {
      needGetLoginUrl = true;
    }
    // settings.RefId = "0";
    // settings.ProcessInstanceId = "";
    settings.ToPage = '';
    settings.journeyBizNo = journeyBizNo;
    settings.ToOrderDetailSerialNo = '';
    if (toPage) {
      settings.ToPage = toPage;
    }
    if (toOrderDetailSerialNo) {
      settings.ToOrderDetailSerialNo = toOrderDetailSerialNo;
    }
    settings.ExternalOrderTravelPassengers = [];
    // if (processInstanceId) {
    // 	settings.ProcessInstanceId = processInstanceId;
    // }
    // if (refId) {
    // 	settings.RefId = refId;
    // }
    if (refId == refConfig.dingdingyifang) {
      settings.DebitType = 0;
    }
    if (platId) {
      settings.platId = platId;
    }
    // if (dingdingRowNumber) {
    // 	settings.ProcessInstanceRowNumber = dingdingRowNumber;
    // }

    if (needGetLoginUrl && EnterpriseId != '54809' && EnterpriseId != '0') {
      EnterpriseId = EnterpriseId == '-1' ? '0' : EnterpriseId;
      this.$app.MemberInfo.MemberId = '';
      this.$app.MemberInfo.Token = '';
      settings.EnterpriseId = EnterpriseId;
      this.$app.MemberInfo.EnterpriseId = EnterpriseId;
      settings.MemberInfo = this.$app.MemberInfo;
      settings.isLogin = false;
      settings.TmpAuthCode = '';
      this.$app.SetSettings(settings);
      param.RedirectUri = this.$app.webSiteUrl;
      param.EnterpriseId = EnterpriseId;
      // this.$app.Loading("获取授权链接...");
      this.$app.Post(apiName.DDGetLoginUrl, param, (data) => {
        if (this.$app.GetResultState(data)) {
          if (data.LoginUrl) {
            window.location.href = data.LoginUrl;
            EnterpriseId = -1;
          }
        }
      });
    } else {
      this.$app.SetSettings(settings);
    }
    const memberInfo = Utils.get(settings, 'MemberInfo', {});
    if (memberInfo.MemberId) {
      this.$Sensors.login({
        MemberId: memberInfo.MemberId,
        Token: memberInfo.Token,
        EnterpriseId: isUrlLogin ? '' : settings.EnterpriseId,
        MemberName: isUrlLogin ? '' : memberInfo.MemberName,
        EnterpriseName: isUrlLogin ? '' : settings.CompanyName,
        PlatId: settings.platId,
        Version: settings.Version,
      });
    }
    //#endif

    const HOLIDAYS = await this.$dataManager.getDBData('globalData', 'HOLIDAYS');
    if (!isEmpty(HOLIDAYS)) {
      this.$dataManager.setMemoryData('HOLIDAYS', HOLIDAYS);
    }
  },
  onShow: function () {},
  onHide: function () {},
};
</script>

<style>
@import './static/icon/ceekeefont.css';
@import './static/icon/ceekeefont500.css';
@import './static/icon/iconFont.css';
@import '@/static/icon/tripwisefont/iconfont.css';
@import url('@/common/css2.0/style.less');
@import '@/static/icon/tripwise-icon-fill/iconfont.css';
@import '@/static/icon/tripwise-icon-outline/iconfont.css';
body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  font-weight: normal;
  background: #ededed;
  color: #333333;
  min-height: 100vh;
  font-family: PingFang SC, Helvetica Neue, Tahoma, Arial, Hiragino Sans GB, Microsoft Yahei, sans-serif;
}

.uni-sample-toast {
  top: 85% !important;
}

uni-toast,
uni-modal {
  z-index: 9999;
}

* {
  box-sizing: border-box;
}

.uni-actionsheet {
  display: none !important;
}

uni-modal {
  z-index: 2000;
  border-radius: 20rpx;
}

uni-modal .uni-modal {
  border-radius: 20rpx;
}

uni-modal .uni-modal__title {
  font-size: 32rpx;
  font-weight: 500;
  color: #000000;
}

uni-modal .uni-modal__bd {
  font-size: 28rpx;
  color: #595959;
  padding: 40rpx 50rpx 80rpx 50rpx;
}

uni-modal .uni-modal__btn {
  font-weight: 500;
  font-size: 32rpx;
}

/* #ifdef APP-PLUS */
.uni-picker {
  bottom: -20px !important;
}

/* #endif */
body.modal-open {
  overflow: hidden;
  width: 100%;
}

/*弹性布局兼容写法*/
.b-flex {
  display: box;
  /* OLD - Android 4.4- */
  display: -webkit-box;
  /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box;
  /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox;
  /* TWEENER - IE 10 */
  display: -webkit-flex;
  /* NEW - Chrome */
  display: flex;
}

.b-justify-between {
  /* 09��*/
  -webkit-box-pack: space-between;
  /* 12��*/
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
}

.b-justify-center {
  /* 09��*/
  -webkit-box-pack: center;
  /* 12��*/
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
}

.b-justify-end {
  /* 09��*/
  -webkit-box-pack: flex-end;
  /* 12��*/
  -webkit-justify-content: flex-end;
  -moz-justify-content: flex-end;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  justify-content: flex-end;
}

.b-justify-start {
  /* 09��*/
  -webkit-box-pack: start;
  /* 12��*/
  -webkit-justify-content: flex-start;
  -moz-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o-justify-content: flex-start;
  justify-content: flex-start;
}

.b-align-centenr,
.b-align-center {
  /* 09��*/
  -webkit-box-align: center;
  /* 12��*/
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}

.b-align-start {
  /* 09��*/
  -webkit-box-align: start;
  /* 12��*/
  -webkit-align-items: flex-start;
  -moz-align-items: flex-start;
  -ms-align-items: flex-start;
  -o-align-items: flex-start;
  align-items: flex-start;
}

.b-align-end {
  /* 09��*/
  -webkit-box-align: end;
  /* 12��*/
  -webkit-align-items: flex-end;
  -moz-align-items: flex-end;
  -ms-align-items: flex-end;
  -o-align-items: flex-end;
  align-items: flex-end;
}

.b-flex-row {
  /* 09��*/
  -webkit-box-orient: horizontal;
  /* 12��*/
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}

.b-flex-column {
  /* 09��*/
  -webkit-box-orient: vertical;
  /* 12��*/
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
}

.b-flex-bettwen {
  /* 09��*/
  -webkit-box-pack: space-between;
  /* 12��*/
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
}

.b-flex-warp {
  /* 09��*/
  /*-webkit-box-lines: multiple;*/
  /* 12��*/
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}

.b-flex-shrink {
  flex-shrink: 0;
}

.b-flex-grow1 {
  -webkit-flex: 1;
  /* Chrome */
  -ms-flex: 1;
  /* IE 10 */
  flex: 1;
  /* NEW, Spec - Opera 12.1, Firefox 20+ */
  -webkit-box-flex: 1;
  /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-flex: 1;
  /* OLD - Firefox 19- */
}

.b-justify-around {
  /* 09��*/
  -webkit-box-pack: space-around;
  /* 12��*/
  -webkit-justify-content: space-around;
  -moz-justify-content: space-around;
  -ms-justify-content: space-around;
  -o-justify-content: space-around;
  justify-content: space-around;
}

/*解决上外边距溢出问题  对子元素设置上外边距 会作用到父元素上*/
.margintop-overflow:before {
  content: '';
  /*生成空内容*/
  display: table;
  /*表现形式为table*/
}

.over-ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.over-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.input-placeholder {
  line-height: 50rpx;
}

page {
  height: 100% !important;
}

a img.csssprite {
  display: none !important;
}

.privacy-container a {
  display: none !important;
}

.amap-logo {
  display: none !important;
  opacity: 0 !important;
}

.amap-copyright {
  opacity: 0 !important;
  display: none !important;
}

uni-toast .uni-icon_toast.uni-loading {
  width: 25px !important;
  height: 25px !important;
  margin: 10px 0 0 !important;
}

uni-toast .uni-toast i,
uni-toast .uni-toast p {
  font-size: 15px !important;
}

uni-toast .uni-toast__content {
  margin: 0 0 10px !important;
}

.pbt-iphone {
  padding-bottom: 20rpx;
}

.over-ellipsis2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.over-ellipsis3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
}

.page-mask {
  position: fixed;
  z-index: 12;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
	.fade-leave-to

	/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>